import { useContext, useEffect, useState } from "react";
import { DashboardContext } from "../../../DashboardContext/DashboardContextProvider";
import RadioGroupField from "../Inputs/RadioGroupField";
import { FormContext } from "../context/FormProvider";
import useSetSlide from "./Hooks/setSlide";
import useInvalidInputs from "./Hooks/useInvalidInputs";

const SafetyServices = ({ setSlideStatus, slideState, formStateLoaded }) => {
  const [disabledInputs, setDisabledInputs] = useState([]);
  const {
    slide9,
    setSlide9,
    setIsLoading,
    requestStatus,
    populateInvalidInputs,
    disabledInputCheck,
  } = useContext(FormContext);

  const { projectId, clientId } = useContext(DashboardContext);

  const slide9Mutation = useSetSlide(
    clientId,
    projectId,
    9,
    setIsLoading,
    setSlideStatus,
  );

  const invalidInputsData = useInvalidInputs(
    clientId,
    projectId,
    requestStatus,
  );

  useEffect(() => {
    populateInvalidInputs(
      invalidInputsData,
      disabledInputs,
      setDisabledInputs,
      "9",
    );
  }, [invalidInputsData.data, invalidInputsData.isFetched]);

  return (
    <>
      {formStateLoaded && (
        <>
          <RadioGroupField
            idProp="safetyInterest"
            label="Are you interested in safety services?"
            state={slide9}
            setState={setSlide9}
            val={slide9.safetyInterest}
            debouncedSave={slide9Mutation}
            setIsLoading={setIsLoading}
            disabledInput={disabledInputCheck("safetyInterest", disabledInputs)}
          />
          {slide9.safetyInterest !== "No" && (
            <>
              <RadioGroupField
                idProp="level1Safety"
                label="Level 1 Safety Inspections"
                state={slide9}
                setState={setSlide9}
                val={slide9.level1Safety}
                debouncedSave={slide9Mutation}
                setIsLoading={setIsLoading}
                disabledInput={disabledInputCheck(
                  "level1Safety",
                  disabledInputs,
                )}
              />
              <p className="important-text">
                {
                  "Level 1 Site Safety Inspection: A basic safety inspection identifying existing and potential hazards and analyzing the overall safety of the site"
                }
              </p>

              <RadioGroupField
                idProp="level2Safety"
                label="Level 2 Safety Inspections"
                state={slide9}
                setState={setSlide9}
                val={slide9.level2Safety}
                debouncedSave={slide9Mutation}
                setIsLoading={setIsLoading}
                disabledInput={disabledInputCheck(
                  "level2Safety",
                  disabledInputs,
                )}
              />
              <p className="important-text">
                {
                  "Level 2 Site Safety Inspection: A more intensive and investigative site assessment that examines the entire site and identifies areas needing remedial action to avoid employee injuries and potential OSHA monetary penalties"
                }
              </p>
            </>
          )}
        </>
      )}
    </>
  );
};

export default SafetyServices;
